const type = 'OPEN_CARD_PASSWORD_CHANGE';

const openCardPasswordChange = () => ({
  type,
});

export { type };
export default openCardPasswordChange;
